import type { ReactNode } from 'react';

type SeverityTone = 0 | 1 | 2 | 3 | 'manual' | 'missing';

interface Props {
  severity: SeverityTone;
  children: ReactNode;
  className?: string;
}

export default function StatusGlow({ severity, children, className = '' }: Props) {
  const toneClass =
    severity === 0
      ? 'ui-status-glow ui-status-glow--0'
      : severity === 1
        ? 'ui-status-glow ui-status-glow--1'
        : severity === 2
          ? 'ui-status-glow ui-status-glow--2'
          : severity === 'manual'
            ? 'ui-status-glow ui-status-glow--manual'
            : severity === 'missing'
              ? 'ui-status-glow ui-status-glow--missing'
            : 'ui-status-glow ui-status-glow--3';

  return (
    <span
      aria-hidden
      className={`${toneClass} ${className} text-white font-semibold`.trim()}
      style={{ color: '#ffffff' }}
    >
      {children}
    </span>
  );
}
